import { RadioGroupComponent, RadioWrapper } from '@hevoio/hevo-ui-toolkit';
import styles from './QueryContainer.module.scss';
import { useState } from 'react';
import IssueTypeContent from '../Issue-type-content/IssueTypeContent';
import QuestionTypeContent from '../question-type-content/QuestionTypeContent';
import { OnGetSolutionHandler, QueryType } from '../../interfaces/query';
import useAnalyticsTracker from '../../../../analytics/hooks/useAnalyticsTracker';
import { ContactSupportAITrackers } from '../../trackers/contact-support-ai-trackers';


export default function QueryContainer({ onGetSolution }: { onGetSolution: OnGetSolutionHandler }) {
  const { eventTrack } = useAnalyticsTracker();
  const [queryType, setQueryType] = useState<QueryType>(QueryType.ISSUE);
  const onQueryTypeChange = (value: string) => {
    eventTrack({
      action: ContactSupportAITrackers.CONTACT_SUPPORT_AI_QUERY_TYPE_CHANGE,
      properties: {
        queryType: value
      }
    });
    setQueryType(value as QueryType);
  };

  return (
    <div className={styles.queryContainer}>
      <div>
        <RadioGroupComponent
          onChange={onQueryTypeChange}
          className='d-flex flex-row'
          name={'query-type'}
          currentValue={queryType}
          defaultValue={QueryType.ISSUE}
        >
          <RadioWrapper
            dataId='query-type-issue'
            radioProps={{ value: QueryType.ISSUE }}
            label='I have an issue'
          />
          <RadioWrapper
            dataId='query-type-question'
            radioProps={{ value: QueryType.QUESTION }}
            label='I have a question'
          />
        </RadioGroupComponent>
      </div>

      {queryType === QueryType.ISSUE ? (
        <IssueTypeContent onGetSolution={onGetSolution} />
      ) : (
        <QuestionTypeContent onGetSolution={onGetSolution} />
      )}
    </div>
  );
}
